// src/components/LanguageSelector.jsx
import React, { useState, useEffect } from 'react';
import { Button, Space } from 'antd';
import i18n from '../i18n';

export default function LanguageSelector() {
  const [language, setLanguage] = useState(
    localStorage.getItem('language') || i18n.language || 'en'
  );

  // whenever `language` state changes, tell i18n and persist
  useEffect(() => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <Space style={{ marginLeft: 30, marginBottom: 10 }}>
      <Button
        type={language === 'en' ? 'primary' : 'default'}
        onClick={() => changeLanguage('en')}
      >
        English
      </Button>
      <Button
        type={language === 'fr' ? 'primary' : 'default'}
        onClick={() => changeLanguage('fr')}
      >
        Français
      </Button>
      <Button
        type={language === 'ar' ? 'primary' : 'default'}
        onClick={() => changeLanguage('ar')}
      >
        العربية
      </Button>
    </Space>
  );
}
